import React from "react"

const Prose = ({children}) => (
    <article className="prose prose-lg max-w-none prose-emerald dark:prose-invert">
        {children}
    </article>
)

export default Prose